import { render, staticRenderFns } from "./OverviewStatistical.vue?vue&type=template&id=68fdaea6&scoped=true"
import script from "./OverviewStatistical.vue?vue&type=script&lang=js"
export * from "./OverviewStatistical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68fdaea6",
  null
  
)

export default component.exports